// Network helpers are shared with SDK hosts that do not run the public web app.
// The public app still validates its complete environment at its root;
// getNetworkConfig independently rejects incomplete network configuration.
type NetworkEnvKey =
  | `NEXT_PUBLIC_${'API_URL' | 'NATS_URL' | 'RPC_URL' | 'PROGRAM_ID' | 'API_KEY'}_${'LOCAL' | 'DEVNET' | 'MAINNET'}`
  | 'NEXT_PUBLIC_DEV_PROXY';
export const networkEnv: Record<NetworkEnvKey, string | undefined> = {
  NEXT_PUBLIC_API_URL_LOCAL: process.env.NEXT_PUBLIC_API_URL_LOCAL,
  NEXT_PUBLIC_NATS_URL_LOCAL: process.env.NEXT_PUBLIC_NATS_URL_LOCAL,
  NEXT_PUBLIC_RPC_URL_LOCAL: process.env.NEXT_PUBLIC_RPC_URL_LOCAL,
  NEXT_PUBLIC_PROGRAM_ID_LOCAL: process.env.NEXT_PUBLIC_PROGRAM_ID_LOCAL,
  NEXT_PUBLIC_API_KEY_LOCAL: process.env.NEXT_PUBLIC_API_KEY_LOCAL,
  NEXT_PUBLIC_API_URL_DEVNET: process.env.NEXT_PUBLIC_API_URL_DEVNET,
  NEXT_PUBLIC_NATS_URL_DEVNET: process.env.NEXT_PUBLIC_NATS_URL_DEVNET,
  NEXT_PUBLIC_RPC_URL_DEVNET: process.env.NEXT_PUBLIC_RPC_URL_DEVNET,
  NEXT_PUBLIC_PROGRAM_ID_DEVNET: process.env.NEXT_PUBLIC_PROGRAM_ID_DEVNET,
  NEXT_PUBLIC_API_KEY_DEVNET: process.env.NEXT_PUBLIC_API_KEY_DEVNET,
  NEXT_PUBLIC_API_URL_MAINNET: process.env.NEXT_PUBLIC_API_URL_MAINNET,
  NEXT_PUBLIC_NATS_URL_MAINNET: process.env.NEXT_PUBLIC_NATS_URL_MAINNET,
  NEXT_PUBLIC_RPC_URL_MAINNET: process.env.NEXT_PUBLIC_RPC_URL_MAINNET,
  NEXT_PUBLIC_PROGRAM_ID_MAINNET: process.env.NEXT_PUBLIC_PROGRAM_ID_MAINNET,
  NEXT_PUBLIC_API_KEY_MAINNET: process.env.NEXT_PUBLIC_API_KEY_MAINNET,
  NEXT_PUBLIC_DEV_PROXY: process.env.NEXT_PUBLIC_DEV_PROXY,
};

// Optional public-host behavior belongs beside the shared network inputs,
// without pulling the public app's required authentication configuration in.
export const publicHostFlags: Readonly<
  Record<'earlyAccessEnabled' | 'devToolkitEnabled', boolean>
> = {
  earlyAccessEnabled: process.env.NEXT_PUBLIC_EARLY_ACCESS_ENABLED === 'true',
  devToolkitEnabled: process.env.NEXT_PUBLIC_DEV_TOOLKIT === '1',
};
